import { SVGAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import SVGIcon, { SVGIconProps } from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'

const logoVariants = cva('block fill-white', {
  variants: {
    variant: {
      default: 'h-[2.1rem] w-[8.5rem] md:h-[2.7rem] md:w-[10.6rem]'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
})

export type LogoProps = SVGAttributes<SVGSVGElement> &
  VariantProps<typeof logoVariants> &
  Pick<SVGIconProps, 'symbol'>

const Logo = ({
  variant,
  symbol = 'logo-icon',

  className,
  ...props
}: LogoProps) => {
  return (
    <SVGIcon
      symbol={symbol}
      className={cn(logoVariants({ variant, className }))}
      {...props}
    />
  )
}

export default Logo
